export default {
  LOAD_NOTIFICATIONS_FORM_PAGE_START: 'LoadNotificationsFormPageStart',
  LOAD_NOTIFICATIONS_FORM_PAGE_END: 'LoadNotificationsFormPageEnd',
  LOAD_NOTIFICATIONS_FORM_PAGE_FACULTIES_START: 'LoadNotificationsFormPageFacultiesStart',
  LOAD_NOTIFICATIONS_FORM_PAGE_FACULTIES_END: 'LoadNotificationsFormPageFacultiesEnd',
  LOAD_NOTIFICATIONS_FORM_PAGE_STUDY_PROGRAMS_START: 'LoadNotificationsFormPageStudyProgramsStart',
  LOAD_NOTIFICATIONS_FORM_PAGE_STUDY_PROGRAMS_END: 'LoadNotificationsFormPageStudyProgramsEnd',
  CLEAR_NOTIFICATIONS_FORM_PAGE: 'ClearNotificationsFormPage'
};